<div class="container">
    <div class="wrapper wrapper--left">
        @for (breadcrumb of breadCrumbs; track breadcrumb; let last = $last) {
        <a
            class="breadcrumb"
            [routerLink]="breadcrumb.href"
            (click)="onItemClicked()"
        >
            {{ breadcrumb.value }}
        </a>
        @if (!last) {
        <span class="breadcrumb breadcrumb--separator">|</span>
        } }
    </div>
    <div class="wrapper wrapper--middle">
        <div
            class="logo theme-logo-background"
            (click)="handleLogoClick()"
        ></div>
    </div>
    <div class="wrapper wrapper--right">
        <div class="content-info content-info--left">
            @if (slideName) {
            <span class="content-info__chapter">{{ slideName.prefix }}</span>
            <span class="content-info__separator">-</span>
            <strong class="content-info__paragraph">{{
                slideName.affix
            }}</strong>
            }
        </div>
        @if (slideName) {
        <div class="content-info content-info--right">
            <app-progress
                [total]="totalResources"
                [current]="currentResourceIndex"
            ></app-progress>
        </div>
        }
    </div>
</div>
